var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"behavior"},[(_vm.isShowText)?_c('ul',{staticClass:"color-details"},[_c('li',[_vm._v("Mastered")]),_c('li',[_vm._v("Inprogress")]),_c('li',[_vm._v("Notstarted")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }